import { CloseOutlined } from "@mui/icons-material";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    TextField,
    Typography
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { ERoles } from "../../config";
import useAuth from "../../hooks/useAuth";

dayjs.extend(utc);

function FilterTransactionModel({ open, searchParams, handleClickOpenModel, handleCloseFilterModel, handleClickSearch }) {
    const { user } = useAuth();
    const dispatch = useDispatch();

    const [search, setSearch] = useState({
        name: searchParams.name,
        userRole: searchParams.userRole || "",
        fromDate: searchParams.fromDate ? dayjs(searchParams.fromDate) : "",
        toDate: searchParams.toDate ? dayjs(searchParams.toDate) : "",
    });

    const handleChange = e => {
        const { value, name } = e.target;
        setSearch({ ...search, [name]: value });
    };

    const handleFromDateChange = date => {
        setSearch(prev => ({ ...prev, fromDate: date }));
    };

    const handleToDateChange = date => {
        setSearch(prev => ({ ...prev, toDate: date }));
    };

    const onClickClear = async () => {
        setSearch({
            name: "",
            userRole: searchParams.userRole,
            fromDate: "",
            toDate: "",
        });
        handleClickSearch({
            name: "",
            userRole: searchParams.userRole,
            fromDate: "",
            toDate: "",
        });
    };

    const onSearch = async () => {
        const formattedFromDate = search.fromDate ? dayjs(search.fromDate).format("YYYY-MM-DD") : null;
        const formattedToDate = search.toDate ? dayjs(search.toDate).format("YYYY-MM-DD") : null;

        await handleClickSearch({
            name: search.name,
            userRole: search.userRole,
            fromDate: formattedFromDate,
            toDate: formattedToDate,
        });
        handleCloseFilterModel();
    };

    return (
        <Dialog open={open} onClose={handleCloseFilterModel} aria-labelledby="filter-dialog-title" fullWidth>
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant="h5">Transactions Filter</Typography>
                <IconButton onClick={handleCloseFilterModel}>
                    <CloseOutlined />
                </IconButton>
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Grid container>
                    <Grid
                        container
                        mt={5}
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <Grid item >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="From Date"
                                    value={dayjs(search.fromDate)}
                                    format="DD-MM-YYYY"
                                    onChange={handleFromDateChange}
                                    renderInput={params => <TextField {...params} fullWidth />}
                                    disableFuture
                                    minDate={dayjs("2024-09-01")}
                                    maxDate={dayjs(search.toDate)}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="To Date"
                                    value={dayjs(search.toDate)}
                                    format="DD-MM-YYYY"
                                    onChange={handleToDateChange}
                                    renderInput={params => <TextField {...params} fullWidth />}
                                    disableFuture
                                    minDate={dayjs(search.fromDate)}
                                    maxDate={dayjs()}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ padding: "1rem 1.5rem", justifyContent: "flex-end", gap: ".25rem" }}>
                <Button variant="outlined" color="error" onClick={onClickClear}>
                    Clear
                </Button>
                <Button variant="contained" color="primary" onClick={onSearch} disabled={!search.fromDate || !search.toDate}>
                    Search
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default FilterTransactionModel;
